import { CSSObject } from '@mui/material'

import { theme } from 'providers/material-ui'

export const TABLE_BORDER: CSSObject['border'] = `1px solid ${theme.palette.grey['300']}` as const
